/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Status_509Inputs */

const vi_carrier_status_509 = /** @type {(inputs: Carrier_Status_509Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chuyển tiếp bưu cục khác`)
};

/**

* @param {Carrier_Status_509Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_status_509 = /** @type {((inputs?: Carrier_Status_509Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Status_509Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_status_509(inputs)
});